import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../../../LoadingIndicator';
import LazyPlaceholder from '../LazyPlaceholder';
import s from './LoadingPlaceholder.scss';
/** What we'll show while we're waiting for the DaEditor chunk to load. */
var LoadingPlaceholder = function () {
    var _a = useState(false), showLoader = _a[0], setShowLoader = _a[1];
    useEffect(function () {
        /*
          One more note: we give a 25ms window for the animation to have time to spin up, want to start giving
          that feedback before we hit that 100ms breakpoint
        */
        var timeout = setTimeout(function () { return setShowLoader(true); }, 75);
        return function () {
            clearTimeout(timeout);
        };
    }, [setShowLoader]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LazyPlaceholder, null),
        React.createElement(LoadingIndicator, { className: classnames(s['loader'], showLoader && s['shown']) })));
};
LoadingPlaceholder.displayName = 'LoadingPlaceholder';
export default LoadingPlaceholder;
//# sourceMappingURL=LoadingPlaceholder.js.map